import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import "./RechartsOverrides.scss";

const AnalyticsLineChart = ({ data, renderTooltip, tickFormatter, yTickFormatter, legends, legendUnit, key1, key2, tickWidth, dy, yTicksGap, axisLabelClass }) => {
    const values = data.map(d => d[key1]);
    const values2 = key2 && data.map(d => d[key2]);
    const min = key2 ? Math.min(...values, ...values2, 0) : Math.min(...values, 0);
    const max = key2 ? Math.max(...values, ...values2, 1) : Math.max(...values, 1);
    const ticks = [];
    let tickGap = null
    
    const getInterval = (length, divisor) => {
        if (length <= divisor) return 0; // Show all ticks if data length is less than or equal to divisor
        const interval = Math.floor(length / divisor) - 1
        return interval;
    }

    if (yTicksGap) { // Ensure the ticks on YAxis are all multiples of a specific value
        const maximo = Math.floor(max);
        const intervalToSpecificCount = getInterval(maximo, 8);
        const multipleOfGap =  Math.ceil(intervalToSpecificCount / yTicksGap);
        tickGap = yTicksGap * multipleOfGap;
    }

    for (let i = Math.ceil(min); i <= Math.floor(max); i++) {
        if (tickGap) {
            if (i * tickGap < Math.floor(max)) {
                ticks.push(i * tickGap);
            } else if (i * tickGap === Math.floor(max)) {
                ticks.push(i * tickGap);
                break;
            }else if ((i * tickGap) === Math.floor(max) + (tickGap - (Math.floor(max) % tickGap))) {
                ticks.push(i * tickGap);
                break;
            }
        } else ticks.push(i);
    }


    return (
        <ResponsiveContainer width="100%" height={300}>
            <LineChart data={data} margin={{ top: 10, right: 40, left: 0, bottom: 0 }}>
                <XAxis
                    tickLine={false}
                    axisLine={false}
                    dataKey="name"
                    interval={data?.length % 2 === 0 ? getInterval(data.length, 6) : getInterval(data.length, 5)}
                    tickFormatter={value => tickFormatter ? tickFormatter(value) : value}
                    dy={dy ? dy : 0}
                    className={axisLabelClass}
                />
                <YAxis
                    axisLine={false}
                    tickLine={false}
                    tickFormatter={value => yTickFormatter ? yTickFormatter(value) : value}
                    ticks={ticks}
                    interval={"preserveStartEnd"}
                    domain={[0, Math.max(...ticks)]} 
                    width={tickWidth ? tickWidth : 70}
                    className={axisLabelClass}
                />
                <CartesianGrid vertical={false} strokeDasharray="3 3" />
                <Tooltip content={renderTooltip} />
                {key2 &&
                    <Line type="monotone" dataKey={key2} strokeWidth={2} stroke="#62d9b7" dot={false} name={`${legends[1]}${legendUnit ? " / " + legendUnit : ""}`} />
                }
                <Line type="monotone" dataKey={key1} strokeWidth={2} stroke="#0E8EFD" dot={false} name={`${legends[0]}${legendUnit ? " / " + legendUnit : ""}`} />
                <Legend align="left" iconType="plainline" wrapperStyle={{ paddingTop: '5px', fontSize: '0.85rem' }} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default AnalyticsLineChart;